export default __webpack_public_path__ + "static/media/raksha_pampliega.e3a2cc14.jpeg";